module.exports = [{
      plugin: require('/Users/johncastberg/code/projects/portfolio/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/johncastberg/code/projects/portfolio/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
